import {connect} from "react-redux";
import PaymentStatement from "./paymentStatement";

export default connect()(PaymentStatement);
